import { Component, Inject, OnInit, Optional } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { SAPstatus } from '../models/samcastatus.entity';
import { AuthenticationService } from '../../../services/authentication.service';
import { SAPstatusService } from '../services/sapstatus.service';
import { FormControl, FormGroup } from '@angular/forms';



@Component({
  selector: 'app-prevision.dialog',
  templateUrl: './prevision.dialog.component.html',
  styleUrls: ['./prevision.dialog.component.css']
})
export class PrevisionDialogComponent implements OnInit {

  // tslint:disable-next-line:variable-name
  public _prevision: any;
  public _sapstatus: SAPstatus[];

  /**
   * prevision form
   */
   previsionForm: FormGroup;

  constructor(
    public dialogRef: MatDialogRef<PrevisionDialogComponent>,
    @Optional()
    @Inject(MAT_DIALOG_DATA)
    public data: any,
    private sapstatusService: SAPstatusService,
    private authenticationService: AuthenticationService) {
  }

  ngOnInit(): void {
    this.previsionForm = new FormGroup({
      TDLNR: new FormControl(null),
      TKNUM: new FormControl(null),
      EXTI2: new FormControl(null),
      EXTI1: new FormControl(null),
      frontPlate: new FormControl(null),
      rearPlate: new FormControl(null),
      ZZMOVIL: new FormControl(null),
      STTRG: new FormControl(null)
    })

    if (this.data) {
      this._prevision = Object.assign(
        new Object(),
        this.data.row
      );
      for (const i in this.previsionForm.controls) {
        if (this.previsionForm.controls.hasOwnProperty(i)) {
          this.previsionForm.controls[i].setValue(this._prevision[i]);
        }
      }
    }
    this.sapstatusService.list().subscribe((sapstatus: SAPstatus[]) => {
      this._sapstatus = sapstatus.filter(status => (Number(status.samcaStatusId) > 7));
    });
  }

  save() {
    for (const i in this.previsionForm.controls) {
      if (this.previsionForm.controls.hasOwnProperty(i) && this.previsionForm.controls[i].value !== null) {
        this._prevision[i] = this.previsionForm.controls[i].value;
      }
    }
    console.log(this._prevision);
    this.dialogRef.close(this._prevision);
  }

  close() {
    this.dialogRef.close();
  }

  isModuleAvailable(moduleId: string) {
    return this.authenticationService.isModuleAvailable(moduleId, true);
}

}